import axios from 'axios'
import store from '@/store'

//  Base HTTP
const $baseHTTP = axios.create({
  baseURL: `${process.env.MINIO_PATH}`,
})

// eslint-disable-next-line consistent-return
$baseHTTP.interceptors.response.use(cfg => cfg, (error) => {
  store.dispatch('tools/setSnackbar', `${error.response && error.response.status ? error.response.status : error}`
    + ` ${error.response && error.response.statusText ? error.response.statusText : ''}`
    + ` ${error.response && error.response.data && error.response.data.message ? error.response.data.message : ''}`)
  return Promise.reject(error)
})

const api = {
  presignedPutObjectUrl(fileName) {
    return $baseHTTP.get(`/put/${fileName}`)
  },

  presignedGetObjectUrls(payload) {
    return $baseHTTP.post('/get', payload)
  },
}

export default api



// WEBPACK FOOTER //
// ./src/services/minio.js